<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2022-01-14 18:35:58
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-26 16:44:33
-->
<template>
  <!-- :style="{ 'min-height': clientHeight }" -->
  <div :class="['screen-container', collspan ? 'isCollspan' : '', isAllScreen ? 'allScreen' : 'noScreen']">
    <div @mousemove="onMove" class="screen-center-container">
      <template v-if="!loadingConfig.mapLoading">
        <template v-for="(item, index) in ringPositionArray">
          <div
            :class="['data-ring-animate', 'd' + index]"
            :key="index"
            :style="{
              right: item[0] / 18 + '%',
              bottom: (item[1] + 200) / 18 + '%',
              animationDelay: item[2],
            }"
          >
            <div :style="{ animationDelay: item[2] }" class="ring-dot"></div>
          </div>
        </template>
      </template>
      <div class="screen-box">
        <div class="total-container">
          <div class="total-wrap" v-loading="loadingConfig.monthLoading">
            <div class="data-wrap">
              <div class="data-item flmin">
                <div class="item-title">{{ $t('screen-board::月累计成交额') }}</div>
                <div class="number">
                  <!-- <ScrollNumber
                  :value="monthData.grandTotalUsdMonth"
                  v-if="monthData.grandTotalUsdMonth"
                  />-->
                  <span v-if="monthData.grandTotalUsdMonth">${{ monthData.grandTotalUsdMonth }}</span>
                  <span v-else>
                    <span>$</span>
                    0.00
                  </span>
                </div>
              </div>
              <div class="data-item">
                <div class="item-title">
                  {{ $t('screen-board::月环比') }}
                  <el-tooltip
                    :content="$t('screen-board::mouth_tooltip')"
                    :disabled="tipDisabled"
                    effect="light"
                    placement="bottom"
                  >
                    <i class="icona-01wenhao3 iconfont"></i>
                  </el-tooltip>
                </div>
                <div
                  :class="[
                    'number',
                    monthData.grandTotalUsdMonthRatio > 0
                      ? 'istop'
                      : monthData.grandTotalUsdMonthRatio < 0
                      ? 'isdown'
                      : '',
                  ]"
                >
                  <!-- <ScrollNumber
                  :value="String(monthData.grandTotalUsdMonthRatio)"
                  v-if="monthData.grandTotalUsdMonthRatio"
                  />-->
                  <span
                    v-if="monthData.grandTotalUsdMonthRatio"
                  >{{ Math.abs(monthData.grandTotalUsdMonthRatio) }}</span>
                  <span v-else>0.00</span>
                  <span class="pz">%</span>
                </div>
              </div>
              <div class="data-item flmin">
                <div class="item-title">
                  {{ $t('screen-board::月目标达成率') }}
                  <!-- <el-popover
                  :append-to-body="false"
                  placement="top"
                  :disabled="tipDisabled"
                  trigger="manual"
                  v-model="showTips"
                  width="200"
                >
                  <div
                    style="font-size: 12px; white-space: initial; padding-right: 20px;position:relative;"
                  >
                    {{ $t('screen-board::mouth_target_tooltip') }}
                    <a
                      @click="routeAtive('/operate-config?type=target')"
                    >{{ $t('screen-board::目标配置') }}</a>
                    {{ $t('screen-board::mouth_target_tooltip_end') }}
                    <i
                      @click="closedTips(false)"
                      class="el-icon-close"
                      style="position: absolute;top: 0px; right: -5px;"
                    ></i>
                  </div>
                  <span id="question-icon" slot="reference">
                    <i class="icona-01wenhao3 iconfont"></i>
                  </span>
                  </el-popover>-->
                  <el-tooltip :disabled="tipDisabled" effect="light" placement="bottom">
                    <div class="big-screen-tip-content" slot="content">
                      {{ $t('screen-board::mouth_target_tooltip') }}
                      <a
                        @click="routeAtive('/operate-config?type=target')"
                      >{{ $t('screen-board::目标配置') }}</a>
                      {{ $t('screen-board::mouth_target_tooltip_end') }}
                    </div>
                    <i class="iconfont icona-01wenhao3"></i>
                  </el-tooltip>
                </div>
                <div class="number">
                  <!-- <ScrollNumber
                  :value="monthData.monthTargetAchievementRate"
                  v-if="monthData.monthTargetAchievementRate"
                  />-->
                  <span
                    v-if="monthData.monthTargetAchievementRate"
                  >{{ monthData.monthTargetAchievementRate }}</span>
                  <span v-else>0.00</span>
                  <span class="pz">%</span>
                </div>
              </div>
              <!-- <div class="data-item">
            <el-popover :append-to-body="false" placement="top" trigger="manual" v-model="showTips" width="350">
              <div style="font-size: 12px; white-space: nowrap">
                {{ $t('screen-board::popver-tip') }}
                <a @click="closedTips">{{ $t('screen-board::经营配置') }}</a>
                {{ $t('screen-board::调整') }}
                <i @click="closedTips(false)" class="el-icon-close"></i>
              </div>
              <div class="item-title" id="question-icon" slot="reference">
                {{ $t('screen-board::毛利率') }}
                <el-tooltip
                  :content="$t('screen-board::tooltip', { pixed: dayData.predictRate || 38 })"
                  effect="light"
                  placement="right"
                >
                  <i class="icona-01wenhao3 iconfont"></i>
                </el-tooltip>
              </div>
            </el-popover>
            <div class="number">
              {{ $dataCheck(dayData.grossMargin) }}
              <span>%</span>
            </div>
              </div>-->
            </div>
          </div>
          <div class="total-wrap center-content" v-loading="loadingConfig.dayLoading">
            <div class="total-number" v-if="dayData.grandTotalUsd">
              <ScrollNumber
                :height="numberHeight"
                :inHeight="inHeight"
                :itemStyle="numberStyle"
                :value="'$' + String(dayData.grandTotalUsd)"
              />
            </div>
            <div class="total-number" v-else>
              <ScrollNumber
                :height="numberHeight"
                :inHeight="inHeight"
                :itemStyle="numberStyle"
                :value="'$0.00'"
              />
            </div>
            <div class="total-box">
              <span class="t-item">
                <span>ROI</span>
                <el-tooltip :disabled="tipDisabled" effect="light" placement="bottom">
                  <div class="big-screen-tip-content" slot="content" v-if="sourceType == 1">
                    {{ $t('screen-board::roi_tooltip') }}
                    <br />
                    <a @click="routeAtive('/stores/shop-site')">{{ $t('screen-board::绑定广告账号') }}</a>
                    {{ $t('screen-board::roi_tooltip_end') }}
                  </div>
                  <div
                    class="big-screen-tip-content"
                    slot="content"
                    v-else
                  >{{ $t('screen-board::roi_tooltip_erp') }}</div>
                  <i class="icona-01wenhao3 iconfont"></i>
                </el-tooltip>
                <span>
                  <!-- <ScrollNumber :value="String(dayData.roi)" class="small-num" v-if="dayData.roi" /> -->
                  <span v-if="dayData.roi">{{ dayData.roi }}</span>
                  <span v-else>-</span>
                </span>
              </span>
              <span class="t-item">
                <span>{{ $t('screen-board::毛利率') }}</span>
                <el-tooltip :disabled="tipDisabled" effect="light" placement="bottom">
                  <div class="big-screen-tip-content" slot="content" v-if="sourceType == 1">
                    {{ $t('screen-board::rate_tooltip') }}
                    <a
                      @click="routeAtive('/stores/shop-site')"
                    >{{ $t('screen-board::绑定广告账号') }}</a>
                    {{ $t('screen-board::rate_tooltip_center_fee') }}
                    <a
                      @click="routeAtive('/products-info')"
                    >{{ $t('screen-board::导入商品信息') }}</a>
                    {{ $t('screen-board::rate_tooltip_center') }}
                    <a
                      @click="routeAtive('/operate-config')"
                    >{{ $t('screen-board::经营配置') }}</a>
                    {{ $t('screen-board::rate_tooltip_end') }}
                  </div>
                  <div class="big-screen-tip-content" slot="content" v-else>
                    {{ $t('screen-board::rate_tooltip_erp') }}
                    <a
                      @click="routeAtive('/operate-config')"
                    >{{ $t('screen-board::经营配置') }}</a>
                    {{ $t('screen-board::rate_tooltip_end') }}
                  </div>
                  <i class="icona-01wenhao3 iconfont"></i>
                </el-tooltip>
                <span>
                  <!-- <ScrollNumber
                  :value="String(dayData.profitRate) + '%'"
                  class="small-num"
                  v-if="dayData.profitRate"
                  />-->
                  <span v-if="dayData.profitRate">{{ dayData.profitRate }}%</span>
                  <span v-else>0.00%</span>
                </span>
              </span>
            </div>
          </div>

          <div class="total-wrap" style="width: 35%" v-loading="loadingConfig.monthLoading">
            <div class="data-wrap">
              <div class="data-item">
                <div class="item-title">{{ $t('screen-board::日环比') }}</div>
                <div
                  :class="[
                    'number',
                    dayData.grandTotalUsdRatio > 0 ? 'istop' : dayData.grandTotalUsdRatio < 0 ? 'isdown' : '',
                  ]"
                >
                  <!-- <ScrollNumber
                  :value="dayData.grandTotalUsdRatio"
                  v-if="dayData.grandTotalUsdRatio"
                  />-->
                  <span v-if="dayData.grandTotalUsdRatio">{{ Math.abs(dayData.grandTotalUsdRatio) }}</span>
                  <span v-else>0.00</span>
                  <span class="pz">%</span>
                </div>
              </div>
              <div class="data-item">
                <div class="item-title">
                  {{ $t('screen-board::客单价') }}
                  <el-tooltip :disabled="tipDisabled" effect="light" placement="bottom">
                    <div
                      class="big-screen-tip-content"
                      slot="content"
                    >{{ $t('screen-board::custom_price_tip') }}</div>
                    <i class="iconfont icona-01wenhao3"></i>
                  </el-tooltip>
                </div>
                <div :class="['number']">
                  <!-- <ScrollNumber :value="String(dayData.customerPrice)" v-if="dayData.customerPrice" /> -->
                  <span v-if="dayData.customerPrice">{{ dayData.customerPrice }}</span>
                  <span v-else>0.00</span>
                </div>
              </div>
              <div class="data-item small-card-item">
                <div class="item-title">
                  {{ $t('screen-board::连带率') }}
                  <el-tooltip :disabled="tipDisabled" effect="light" placement="bottom">
                    <div
                      class="big-screen-tip-content"
                      slot="content"
                    >{{ $t('screen-board::more_rate_tip') }}</div>
                    <i class="iconfont icona-01wenhao3"></i>
                  </el-tooltip>
                </div>
                <div class="number">
                  <!-- <ScrollNumber
                  :value="String(dayData.associatedPurchaseRate)"
                  v-if="dayData.associatedPurchaseRate"
                  />-->
                  <span v-if="dayData.associatedPurchaseRate">{{ dayData.associatedPurchaseRate }}</span>
                  <span v-else>0.00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line-box">
          <div class="line-content">
            <div class="wrap">
              <div class="light-move-right">
                <img class="light-icon" src="@/assets/images/light.png" />
              </div>
              <!-- <div class="light-move-left">
              <img class="light-icon" src="@/assets/images/light.png" />
              </div>-->
            </div>
          </div>
        </div>
        <div class="main-content-box">
          <div class="product-box">
            <div class="goods-wrap" v-loading="loadingConfig.productLoading">
              <div class="goods-title">
                {{ $t('screen-board::店铺日成交排行榜') }}
                <span
                  @click="routeAtive('/day-report', params)"
                  class="more"
                >
                  {{ $t('screen-board::more') }}
                  <i class="iconfont icona-06xiala left-icon"></i>
                </span>
              </div>
              <div class="goods-list">
                <ScrollsBar ref="scroll1">
                  <div class="table-padding">
                    <table class="table-box">
                      <thead>
                        <tr>
                          <td class="th">{{ $t('screen-board::店铺') }}</td>
                          <td class="th">{{ $t('screen-board::日成交额') }}</td>
                          <td class="th">{{ $t('screen-board::日环比') }}</td>
                          <td class="th">{{ $t('screen-board::月成交额') }}</td>
                        </tr>
                      </thead>
                      <tbody v-if="products.length">
                        <tr :key="index" class="goods-item" v-for="(item, index) in products">
                          <td class="gd-title">
                            <span class="dot-icon-span">
                              <img
                                class="dot-icon"
                                src="@/assets/images/d0.png"
                                v-if="item.rank == 1"
                              />
                              <img
                                class="dot-icon"
                                src="@/assets/images/d1.png"
                                v-else-if="item.rank == 2"
                              />
                              <img
                                class="dot-icon"
                                src="@/assets/images/d2.png"
                                v-else-if="item.rank == 3"
                              />
                              <span class v-else>{{ Number(item.rank).toFixed(0) }}</span>
                            </span>

                            <span
                              :title="item.brandName"
                              class="one-line title"
                            >{{ item.brandName }}</span>
                            <span class="dot-t dot" v-if="item.rankDiff > 0">
                              <i class="iconfont iconic-shangsheng"></i>
                              {{ Math.abs(item.rankDiff) }}
                            </span>
                            <span class="dot-d dot" v-else-if="item.rankDiff < 0">
                              <i class="iconfont iconic-xiajiang"></i>
                              {{ Math.abs(item.rankDiff) }}
                            </span>
                            <span class="dot" v-else>
                              <i class="dot-span-tip">-</i>
                              {{ Math.abs(item.rankDiff) }}
                            </span>
                          </td>
                          <td>${{ $dataCheck(formatNumberMix(item.grandTotalUsd, 2, '', '')) }}</td>
                          <td class="td-rate">
                            <span class="dot-t dot" v-if="item.grandTotalUsdRatio > 0">
                              <i class="iconfont iconic-shangsheng"></i>
                            </span>
                            <span class="dot-d dot" v-else-if="item.grandTotalUsdRatio < 0">
                              <i class="iconfont iconic-xiajiang"></i>
                            </span>
                            <span class="dot" v-else>
                              <i class="dot-span-tip">-</i>
                            </span>
                            {{ $dataCheck(formatNumberMix(Math.abs(item.grandTotalUsdRatio), 2, '', '%')) }}
                          </td>
                          <td>${{ $dataCheck(formatNumberMix(item.grandTotalUsdMonth, 2, '', '')) }}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td class="empty-td" colspan="4">
                            <img class="empty-img" src="@/assets/images/empty1.png" />
                            <div class="empty-content">
                              <div>{{ $t('screen-board::shop_empty') }}</div>
                              <a
                                @click="$store.commit('setShopVisiable', { visiable: true })"
                                class="empty-a"
                              >{{ $t('screen-board::shop_empty_tip') }}</a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ScrollsBar>
              </div>
            </div>
            <div class="goods-wrap last-margin" v-loading="loadingConfig.spuLoading">
              <div class="goods-title">
                {{ $t('screen-board::SPU日销量排行榜') }}
                <span
                  @click="routeAtive('/day-report', params)"
                  class="more"
                >
                  {{ $t('screen-board::more') }}
                  <i class="iconfont icona-06xiala left-icon"></i>
                </span>
              </div>
              <div class="goods-list">
                <ScrollsBar ref="scroll2">
                  <div class="table-padding">
                    <table class="table-box">
                      <thead>
                        <tr>
                          <td class="th">{{ $t('screen-board::SPU') }}</td>
                          <td class="th">{{ $t('screen-board::日销量') }}</td>
                          <td class="th">{{ $t('screen-board::日环比') }}</td>
                          <td class="th">{{ $t('screen-board::月成交额') }}</td>
                        </tr>
                      </thead>
                      <tbody v-if="spuDatas.length">
                        <tr :key="index" class="goods-item" v-for="(item, index) in spuDatas">
                          <td class="gd-title">
                            <span class="dot-icon-span">
                              <img
                                class="dot-icon"
                                src="@/assets/images/d0.png"
                                v-if="item.rank == 1"
                              />
                              <img
                                class="dot-icon"
                                src="@/assets/images/d1.png"
                                v-else-if="item.rank == 2"
                              />
                              <img
                                class="dot-icon"
                                src="@/assets/images/d2.png"
                                v-else-if="item.rank == 3"
                              />
                              <span class v-else>{{ Number(item.rank).toFixed(0) }}</span>
                            </span>
                            <span class="title">
                              <el-tooltip
                                class="item"
                                effect="dark"
                                placement="right"
                                popper-class="big-screen-tip-img"
                              >
                                <div slot="content">
                                  <zImg :src="item.spuImage" class="img-size" />
                                </div>
                                <zImg :src="item.spuImage" class="img-size" />
                              </el-tooltip>

                              <span :title="item.spuName" class="one-line fx">{{ item.spuName }}</span>
                            </span>
                            <span class="dot-t dot" v-if="item.rankDiff > 0">
                              <i class="iconfont iconic-shangsheng"></i>
                              {{ Math.abs(item.rankDiff) }}
                            </span>
                            <span class="dot-d dot" v-else-if="item.rankDiff < 0">
                              <i class="iconfont iconic-xiajiang"></i>
                              {{ Math.abs(item.rankDiff) }}
                            </span>
                            <span class="dot" v-else>
                              <i class="dot-span-tip">-</i>
                              {{ Math.abs(item.rankDiff) }}
                            </span>
                          </td>
                          <td>{{ $dataCheck(formatNumberMix(item.spuNum, 0, '', '')) }}</td>
                          <td class="td-rate">
                            <span class="dot-t dot" v-if="item.spuNumRatio > 0">
                              <i class="iconfont iconic-shangsheng"></i>
                            </span>
                            <span class="dot-d dot" v-else-if="item.spuNumRatio < 0">
                              <i class="iconfont iconic-xiajiang"></i>
                            </span>
                            <span class="dot" v-else>
                              <i class="dot-span-tip">-</i>
                            </span>
                            {{ $dataCheck(formatNumberMix(Math.abs(item.spuNumRatio), 2, '', '%')) }}
                          </td>
                          <td>${{ $dataCheck(formatNumberMix(item.grandTotalUsdMonth, 2, '', '')) }}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td class="empty-td" colspan="4">
                            <img class="empty-img" src="@/assets/images/empty2.png" />
                            <div class="empty-content empty-tip-content-info">
                              {{ $t('screen-board::noshop_empty_tip') }}
                              <el-tooltip
                                :append-to-body="false"
                                :popperOptions="popperEmptyOptions"
                                effect="light"
                                placement="bottom"
                              >
                                <div class="big-screen-tip-content" slot="content">
                                  <div class="t-item">{{ $t('screen-board::noshop_empty_tip_1') }}</div>
                                  <div class="t-item">{{ $t('screen-board::noshop_empty_tip_2') }}</div>
                                  <div class="t-item">{{ $t('screen-board::noshop_empty_tip_3') }}</div>
                                </div>
                                <i class="iconfont icona-01wenhao3"></i>
                              </el-tooltip>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ScrollsBar>
              </div>
            </div>
          </div>
        </div>
        <Map :config="mapConfig" @changeZone="changeZone" @inited="onInitMap" ref="mapContainer"></Map>
        <div class="update-time-wrap">
          <div class="update-time-position">
            <span class="mr-8">
              {{ $t('screen-board::数据更新') }}
              <el-tooltip :disabled="tipDisabled" effect="light" placement="bottom">
                <div class="big-screen-tip-content" slot="content">
                  <div class="t-item">更新频率：10分钟</div>
                </div>
                <i class="iconfont icona-01wenhao3"></i>
              </el-tooltip>
              ：{{ updateTime }}
            </span>
            <i class="iconfont iconCalendar date-icon"></i>
            <el-date-picker
              :clearable="false"
              :picker-options="pickerOptions"
              @change="timeChange"
              popper-class="date-input-cell"
              size="small"
              type="date"
              v-model="params.dt"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </div>
        </div>
        <handleIcon
          :isAllScreen="isAllScreen"
          @allScreen="toggleAllScreenFull(!isAllScreen)"
          v-if="!moveChecked"
        >
          <template slot="menu">
            <li @click="getScreenInfo">
              <div class="icon">
                <i class="iconfont iconRefresh"></i>
              </div>
              <span>{{ $t('dashboard-bi::default-board::refresh') }}</span>
            </li>
          </template>
        </handleIcon>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import echartsJson from '../../../public/js/echart/customed.json'
import { worldJson } from './config/world'
import ScrollNumber from '@/components/scroll-number/src/index'
import { formatNumberMix } from '@/utils'
import { _local } from '@/utils/storage'
import { toggleAllScreen } from '@/utils/utils.js'
import { addResizeListener, removeResizeListener } from '@/utils/resize-event'
import handleIcon from '@/components/handle-icon/index.vue'
import Map from './map/index.vue'
import {
  newGetBigScreencountryData,
  newGetBigScreencountryLnglat,
  newGetBigScreencMonthData,
  newGetBigScreencDayData,
  newGetBigScreencShopData,
  newGetBigScreencSpuSaleData,
} from '@/server/etl'
moment.locale('zh-cn')
export default {
  name: 'big-screen',
  components: { handleIcon, Map, ScrollNumber },
  data () {
    return {
      lnglat: [],
      numberHeight: 48,
      numberStyle: {},
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() >= Date.parse(new Date())
        },
      },
      clientHeight: '100%',
      locationIcon: require('@/assets/images/bigScreen/location.png'),
      countryFocusInterval: null,
      refreshInterval: null,
      listenAllScreenKeyUp: null, // 监听全屏案件
      myChart: null,
      showTips: false,
      moveChecked: false,
      scatterData: [],
      monthData: {},
      ringPositionArray: [
        [180, 400, Math.random() * 20 + 's'],
        [320, 200, Math.random() * 20 + 's'],
        [220, 380, Math.random() * 20 + 's'],
        [590, 700, Math.random() * 20 + 's'],
        [620, 740, Math.random() * 20 + 's'],
        [350, 650, Math.random() * 20 + 's'],
        [670, 680, Math.random() * 20 + 's'],
        [320, 620, Math.random() * 20 + 's'],
        [450, 690, Math.random() * 20 + 's'],
        [570, 580, Math.random() * 20 + 's'],
        [1040, 710, Math.random() * 20 + 's'],
        [850, 600, Math.random() * 20 + 's'],
        [150, 300, Math.random() * 20 + 's'],
        [800, 300, Math.random() * 20 + 's'],
        [300, 550, Math.random() * 20 + 's'],
        [360, 760, Math.random() * 20 + 's'],
      ],
      dayData: {},
      params: {
        dt: moment().format('YYYY-MM-DD HH:mm:ss'),
        org_unit_id: this.$store.state.user.merchantId,
        // countryCode: '',
        // countryName: '',
      },
      popperEmptyOptions: {
        boundariesElement: '.empty-tip-content-info',
        gpuAcceleration: true,
      },
      popperOptions: {
        boundariesElement: '.total-container',
        gpuAcceleration: true,
      },
      updateTime: '',
      updateTimeSet: moment(),
      products: [],
      spuDatas: [],
      orderSource: [],
      loadingConfig: {
        mapLoading: false,
        mapInit: false,
        monthLoading: false,
        dayLoading: false,
        productLoading: false,
        spuLoading: false,
      },
      clickAndMove: false,
      tipDisabled: false,
      mapConfig: {
        formatter: [
          { name: this.$t('screen-board::月成交额'), key: 'grandTotalUsdMonth', unit: '$' },
          { name: this.$t('screen-board::月订单量'), key: 'orderNum', unit: '' },
          { name: this.$t('screen-board::客单价'), key: 'customerPrice', unit: '$' },
        ],
      },
      timmer: null,
      timeoutMove: null,
      resizeTimeout: null,
      //记录鼠标值
      moveEvent: 0,
      timerMoveEvent: null,
    }
  },
  beforeRouteLeave (to, from, next) {
    this.tipDisabled = true
    this.$refs.mapContainer.myChart.dispatchAction({
      type: 'downplay',
      seriesIndex: 0,
    })
    this.clickAndMove = true
    const doms = document.querySelectorAll('.map-tooltip-wrapper')
    doms.forEach(item => {
      item.style.display = 'none'
    })

    this.$nextTick(() => next())
  },
  activated () {
    this.tipDisabled = false
    this.moveEvent = false
    this.clickAndMove = false
  },
  created () {
    this.udpateNumber()
  },
  watch: {
    isAllScreen (bool) {
      this.clickAndMove = false

      if (bool) {
        this.moveChecked = true
      } else {
        this.moveChecked = false
      }
      this.udpateNumber()
    },
  },
  async mounted () {
    setTimeout(() => {
      if (_local.get('report_local') && _local.get('report_local').bigScreen !== undefined) {
        this.showTips = !!_local.get('report_local').bigScreen
      } else {
        this.showTips = true
      }
    }, 1000)

    // 读取全球地图
    // worldJson(this, echarts)
    // echarts.registerTheme('customed', echartsJson)
    // // 初始化地图
    // this.initMapConfig()
    const { data } = await newGetBigScreencountryLnglat()
    if (data.code == 0) {
      this.lnglat = data.data.datas
    }

    // this.refreshInterval = setInterval(() => {
    //   this.getScreenInfo()
    // }, 600000)
    this.$nextTick(() => {
      // 监听全屏事件
      this.screenEvent()
      window.addEventListener('resize', () => {
        if (this.$refs.mapContainer.myChart) {
          if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout)
          }
          this.resizeTimeout = setTimeout(() => {
            this.$refs.mapContainer.myChart.resize()
            // this.$root.$children[0].$children[0].scroll.update()
          }, 60)
        }
      })
    })
    // 设置时间监听
    if (!this.timmer && this.updateTimeSet) {
      const min = this.updateTimeSet.minute()
      if (min % 10 == 0) {
        this.updateTime = '刚刚'
      } else {
        this.updateTime = (min % 10) + '分钟前'
      }
      this.timmer = setInterval(() => {
        console.log('60S', this.updateTimeSet)
        const min = this.updateTimeSet.minute()
        if (min % 10 == 0) {
          this.getScreenInfo()
          this.updateTime = '刚刚'
        } else {
          this.updateTime = (min % 10) + '分钟前'
        }
      }, 6000)
    }
  },

  methods: {
    udpateNumber () {
      if (this.isAllScreen) {
        this.numberHeight = (window.innerWidth * 70) / 1280
        this.inHeight = (window.innerWidth * 90) / 1280
        this.numberStyle = { height: (window.innerWidth * 90) / 1280 + 'px' }
        this.moveChecked = true
      } else {
        this.numberHeight = (window.innerWidth * 56) / 1280
        this.inHeight = (window.innerWidth * 76) / 1280
        this.numberStyle = { height: (window.innerWidth * 76) / 1280 + 'px' }
      }
    },
    findLngLat (name) {
      const data = this.lnglat.find(item => item.name == name)
      return data
    },
    onMove (e) {
      if (this.isAllScreen) {
        this.moveEvent += 1
        if (this.moveEvent > 20) {
          this.moveChecked = false
          this.moveEvent = 21
          if (!this.timerMoveEvent) {
            this.timerMoveEvent = setInterval(() => {
              this.moveEvent -= 1
              if (this.moveEvent <= 0) {
                this.moveEvent = 0
                this.moveChecked = true
                clearInterval(this.timerMoveEvent)
                this.timerMoveEvent = null
              }
            }, 100)
          }
        }
      } else {
        if (this.timerMoveEvent) {
          this.moveChecked = false
          clearInterval(this.timerMoveEvent)
        }
      }
    },

    routeAtive (path, params) {
      this.tipDisabled = true
      if (params) {
        this.$store.dispatch('setUpdateRouter', path)
      }
      this.$router.push({ path: path, query: params ? params : {} })
    },
    formatNumberMix,
    timeChange () {
      if (moment(this.params.dt).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
        this.params.dt = moment().format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.params.dt = this.params.dt.replace('00:00:00', '23:59:59')
      }
      this.scatterData = []
      this.orderSource = []
      this.spuDatas = []
      this.products = []
      this.monthData = {}
      this.dayData = {}
      this.getScreenInfo()
    },
    getScreenInfo (init) {
      const local = moment()
      local.locale('zh-cn')
      this.updateTimeSet = local
      !init && this.getMapInfo()
      this.getMonthInfo()
      this.getDayInfo()
      this.getProductInfo()
      this.getSpuSaleInfo()
      // this.updateTime = this.updateTimeSet.from(moment());
      // moment.locale('zh-cn');
      // this.updateTimeSet = moment()
    },
    onInitMap (bool) {
      this.loadingConfig.mapInit = bool
      this.getScreenInfo()
    },

    changeZone (params) {
      if (
        (params.type == 'mousemove' || params.type == 'click') &&
        (params.componentType == 'geo' || params.seriesType == 'effectScatter')
      ) {
        this.clickAndMove = true
        this.$refs.mapContainer.myChart.dispatchAction({
          type: 'hideTip',
        })
        this.$refs.mapContainer.myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          name: params.name,
        })
      }
      //  if ((params.type == 'click') && params.seriesType == 'map') {
      //   this.clickAndMove = true;
      //   const lnglat = this.findLngLat(params.name)
      //   this.$refs.mapContainer.myChart.dispatchAction({
      //     type: 'hideTip',
      //     seriesIndex: 0,
      //   })
      //   if (this.timeoutMove) {
      //     clearTimeout(this.timeoutMove)
      //   }
      //   this.timeoutMove = setTimeout(() => {
      //     this.$refs.mapContainer.myChart.dispatchAction({
      //       type: 'showTip',
      //       seriesIndex: 0,
      //       name: params.name
      //     })
      //   })
      // }
    },
    async getMapInfo () {
      this.clickAndMove = false
      this.loadingConfig.mapLoading = true
      const { data } = await newGetBigScreencountryData({ ...this.params })
      this.loadingConfig.mapLoading = false

      if (data.code === this.$code) {
        this.scatterData =
          data.data.datas.length > 0
            ? data.data.datas
              .map((scatter, index) => ({
                name: scatter.countryName,
                latitude: scatter.latitude,
                longitude: scatter.longitude,
                value: scatter.grandTotalUsdMonth,
                data: { ...scatter },
              }))
              .sort((a, b) => {
                return b.value - a.value
              })
            : this.scatterData
      }
      const maxValue =
        data.data.datas &&
        Math.max.apply(
          null,
          data.data.datas.map(item => item.grandTotalUsdMonth)
        )
      const minValue =
        data.data.datas &&
        Math.min.apply(
          null,
          data.data.datas.map(item => item.grandTotalUsdMonth)
        )
      const rValue = (maxValue - minValue) / 2
      const length = data.data.datas.length
      const maxLngLat = data.data.datas.sort(function (a, b) {
        return b.grandTotalUsdMonth - a.grandTotalUsdMonth
      })
      const convertData = dt => {
        return dt.map(item => {
          return {
            name: item.name,
            value: [item.longitude, item.latitude, item],
          }
        })
      }
      const resdata = convertData(this.scatterData)
      this.$refs.mapContainer.myChart.setOption(
        {
          // 设置echarts数据
          series: [
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              data: resdata,
              effectType: 'ripple',
              showEffectOn: 'render',
              rippleEffect: {
                brushType: 'stroke',
                scale: 2.5,
              },
              clip: true,
              hoverAnimation: true,
              symbolSize: function (val) {
                return (
                  (((val[2].value / rValue) * length > 1 ? (val[2].value / rValue) * length : 1) * window.innerWidth) /
                  1440
                )
                // return val[2].value / rValue * length
              },
            },
          ],
        },
        false
      )
      let showIndex = 0
      if (this.countryFocusInterval) {
        // 隐藏之前显示的
        this.$refs.mapContainer.myChart.dispatchAction({
          type: 'hideTip',
          seriesIndex: 0,
        })
        clearInterval(this.countryFocusInterval)
      }
      this.$refs.mapContainer.myChart.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        name: this.scatterData[showIndex] && this.scatterData[showIndex].name,
      })
      setTimeout(() => {
        // 前十国家循环显示tooltips
        this.$refs.mapContainer.myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          name: this.scatterData[showIndex] && this.scatterData[showIndex].name,
        })
        this.countryFocusInterval = setInterval(() => {
          if (!this.clickAndMove) {
            if (showIndex < 10) {
              showIndex++
            } else {
              showIndex = 0
            }
            this.$refs.mapContainer.myChart.dispatchAction({
              type: 'hideTip',
              seriesIndex: 0,
            })
            this.$refs.mapContainer.myChart.dispatchAction({
              type: 'showTip',
              seriesIndex: 0,
              name: this.scatterData[showIndex] && this.scatterData[showIndex].name,
            })
          }
        }, 8000)
      }, 400)
      // setTimeout(() => {

      //   this.countryFocusInterval = setInterval(() => {
      //     if (!this.clickAndMove) {
      //       if (showIndex < 10) {
      //         showIndex++
      //       } else {
      //         showIndex = 0
      //       }
      //       if (this.scatterData[showIndex - 1]) {
      //         this.$refs.mapContainer.myChart.dispatchAction({
      //           type: 'hideTip',
      //           seriesIndex: 0,
      //           name: this.scatterData[showIndex - 1].name,
      //         })
      //         this.$refs.mapContainer.myChart.dispatchAction({
      //           type: 'downplay',
      //           seriesIndex: 0,
      //           name: this.scatterData[showIndex - 1].name,
      //         })
      //       }
      //       this.$refs.mapContainer.myChart.dispatchAction({
      //         type: 'highlight',
      //         seriesIndex: 0,
      //         name: this.scatterData[showIndex].name,
      //       })

      //       this.$refs.mapContainer.myChart.dispatchAction({
      //         type: 'showTip',
      //         seriesIndex: 0,
      //         name: this.scatterData[showIndex].name,
      //       })
      //     }
      //   }, 8000)
      // }, 2000)
    },
    async getRingInfo (data = []) {},
    async getMonthInfo () {
      this.loadingConfig.monthLoading = true
      const { data } = await newGetBigScreencMonthData({ ...this.params })
      this.loadingConfig.monthLoading = false
      if (data.code === this.$code) {
        if (data.data.datas && data.data.datas.length) {
          this.monthData = data.data.datas[0]
        }
      }
    },
    async getDayInfo () {
      this.loadingConfig.dayLoading = true
      const { data } = await newGetBigScreencDayData({ ...this.params })
      this.loadingConfig.dayLoading = false
      if (data.code === this.$code) {
        if (data.data.datas && data.data.datas.length) {
          this.dayData = data.data.datas[0]
        }
      }
    },
    async getProductInfo () {
      this.loadingConfig.productLoading = true
      const { data } = await newGetBigScreencShopData({ ...this.params })
      this.loadingConfig.productLoading = false
      if (data.code === this.$code) {
        this.products = data.data.datas
      }
    },
    async getSpuSaleInfo () {
      this.loadingConfig.spuLoading = true
      const { data } = await newGetBigScreencSpuSaleData({ ...this.params })
      this.loadingConfig.spuLoading = false
      if (data.code === this.$code) {
        this.spuDatas = data.data.datas
      }
    },
    closedTips (route = true) {
      this.showTips = false
      let local = _local.get('report_local') || {}
      local.bigScreen = Number(this.showTips)
      this.$store.dispatch('updateUserInfoConfig', local)
      if (route) {
        this.$router.push('/operate-config')
      }
    },
    toggleAllScreenFull (bool) {
      // this.$store.commit('setScreen', bool)
      toggleAllScreen()
      this.clickAndMove = false
      if (bool) {
        this.moveChecked = true
      } else {
        this.moveChecked = false
      }

      this.$refs.scroll1 && this.$refs.scroll1.update()
      this.$refs.scroll2 && this.$refs.scroll2.update()
       try {
            this.$parent.$parent.update()
          } catch (e) {
            console.log(e)
          }
    },
    screenEvent () {
      this.listenAllScreenKeyUp = e => {
        //   /*判断是否全屏*/
        var isFullscreen =
          document.fullScreenElement || // W3C
          document.msFullscreenElement || // IE
          document.mozFullScreenElement || // 火狐
          document.webkitFullscreenElement || // 谷歌
          false
        this.$store.commit('setScreen', isFullscreen ? true : false)
        // this.clientHeight = isFullscreen ? window.innerHeight + 'px' : window.innerHeight - 96 + 'px'
        setTimeout(() => {
          try {
            this.$parent.$parent.update()
          } catch (e) {
            console.log(e)
          }
        }, 100)
      }
      var isFullscreen =
        document.fullScreenElement || // W3C
        document.msFullscreenElement || // IE
        document.mozFullScreenElement || // 火狐
        document.webkitFullscreenElement || // 谷歌
        false
      // this.clientHeight = isFullscreen ? window.innerHeight + 'px' : window.innerHeight - 96 + 'px'
      this.clientHeight = document.getElementById('boardShowWrap').clientHeight - 36 + 'px'
      addResizeListener(document.body, this.listenAllScreenKeyUp)
    },
  },
  computed: {
    sourceType () {
      return this.$store.state.user.sourceType
    },
    collspan () {
      return this.$store.state.menu.collapse
    },
    isAllScreen () {
      return this.$store.state.isAllScreen
    },
  },
  beforeDestroy () {
    // clearInterval(this.refreshInterval)
    clearInterval(this.countryFocusInterval)
    removeResizeListener(this.listenAllScreenKeyUp)
  },
}
</script>
<style lang="scss">
.date-input-cell {
  transform: translateX(-30px);
}
.big-screen-tip-img {
  background: none !important;
  padding: 0 !important;
}
.big-screen-tip-img .img-size {
  width: 120px * 100vw / 1440px;
  height: 120px * 100vw / 1440px;
  border: inherit !important;
}
.big-screen-tip-content {
  line-height: 20px;
  max-width: 14vw;
}
</style>
<style scoped lang="scss">
$maxWidth: 1378px;
$minWidth: 1600px;

.screen-container {
  overflow: hidden;
  user-select: none;
  .screen-center-container {
    position: relative;
    box-sizing: border-box;
    padding: trl(34px) trl(40px);
   min-height: calc(100vh - 96px);
  }
  /deep/.img-size {
    width: trl(16px);
    height: trl(16px);
    vertical-align: middle;
  }
  /deep/.scroll-number-item .number-item {
    font-size: trl(24px);

    font-family: 'Manrope_SemiBold';
    @media screen and (max-width: $maxWidth) {
      font-size: trl(18px);
    }
  }
  /deep/.scroll-number .digit {
    span {
      font-size: trl(24px);
      font-family: 'Manrope_SemiBold';
      @media screen and (max-width: $maxWidth) {
        font-size: trl(18px);
      }
    }
  }

  position: relative;
  background: #010a20;
  color: #fff;
  box-sizing: border-box;

  overflow: hidden;
  width: calc(100vw - 220px) !important;

  &.isCollspan {
    width: calc(100vw - 82px) !important;
  }
  //  @media screen and (max-width:1500px) {
  //   margin-top:  trl(-32px);
  // }

  // min-height: calc(100vh - 96px);
  // overflow: auto;
  font-size: 1vw;
  .total-container {
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 5;
    //    &:hover {
    //       .icona-01wenhao3 {
    //         display: inline-block!important;
    //       }
    //     }
  }
  .total-wrap {
    width: 32%;

    display: inline-block;
    border-radius: trl(10px);
    .title {
      font-size: trl(14px);
      padding: trl(24px);
      color: #fff;
    }
    .data-wrap {
      display: flex;
      justify-content: space-between;
      padding: 0;
      .data-item {
        padding: 0 3%;
        flex: 1;
        z-index: 1;
        text-align: left;
        position: relative;
        &.small-card-item {
          max-width: trl(80px);
        }

        //  .icona-01wenhao3 {
        //    display: none;
        //  }
        //
        &.flmin {
          padding: 0 3%;
          // min-width: trl(152px);
          // @media screen and (max-width: $maxWidth) {
          //   min-width: trl(132px);
          // }
        }
        &:first-child {
          padding-left: 0;
          padding-right: 8%;
        }
        &:last-child {
          padding-right: 0;
        }
        .item-title {
          white-space: nowrap;
          font-size: trl(14px);
          font-weight: 300;
          color: rgba(255, 255, 255, 0.75);
          margin-bottom: trl(5px);
          @media screen and (max-width: $maxWidth) {
            font-size: trl(12px);
          }
        }
        .number {
          font-size: trl(24px);
          font-family: 'Manrope_SemiBold';
          position: relative;
          white-space: nowrap;
          font-weight: bold;
          display: flex;
          color: #ffff;
          /deep/ .scroll-number-item {
            line-height: inherit;
          }

          &.isdown {
            &::after {
              content: '';
              position: absolute;
              left: -1vw;
              top: 0.8vw;
              border-top: trl(6px) solid #00b929;
              border-right: trl(4px) solid transparent;
              border-left: trl(4px) solid transparent;
            }
          }
          &.istop {
            &::after {
              content: '';
              position: absolute;
              left: -1vw;
              top: 0.8vw;
              border-bottom: trl(6px) solid #fd2d2e;
              border-right: trl(4px) solid transparent;
              border-left: trl(4px) solid transparent;
            }
          }
          .pz {
            font-size: trl(24px);
            line-height: trl(33px);
          }
        }
        .el-icon-close {
          cursor: pointer;
          font-size: trl(14px);
          color: #999;
          margin-left: trl(12px);
        }
      }
    }
  }
  .icona-01wenhao3 {
    cursor: pointer;
    margin-left: 2px;
    color: rgba(255, 255, 255, 0.5);
    font-size: trl(14px);
  }
  .center-content {
    width: 36%;
    transform: translateY(0);
    // @media screen and (max-width: $maxWidth) {
    //     width: 36%;
    // }
    text-align: center;
    /deep/ .scroll-number-item {
      // line-height: trl(63px);
      line-height: inherit;
    }
    /deep/.scroll-number-item .number-item {
      font-size: trl(56px);
      font-family: 'Manrope_SemiBold';
    }
    /deep/.scroll-number .digit {
      span {
        font-size: trl(56px);
        font-family: 'Manrope_SemiBold';
      }
    }
    .small-num {
      position: relative;
      /deep/.scroll-number-item {
        line-height: inherit;
      }
      /deep/.scroll-number-item .number-item {
        font-size: trl(14px);
        color: #fff;
        font-family: 'PingFang SC', 'Helvetica Neue', 'Microsoft YaHei UI', 'Microsoft YaHei', 'Noto Sans CJK SC', Sathu,
          EucrosiaUPC, Arial, Helvetica, sans-serif;
      }
      /deep/ .digit {
        span {
          color: #fff;
          font-family: 'PingFang SC', 'Helvetica Neue', 'Microsoft YaHei UI', 'Microsoft YaHei', 'Noto Sans CJK SC',
            Sathu, EucrosiaUPC, Arial, Helvetica, sans-serif;
          font-size: trl(14px);
        }
      }
    }
    .total-number {
      padding: 0 trl(20px);
      font-size: trl(56px);
      font-family: 'Manrope_SemiBold';
      color: #ffb81c;
      position: relative;
      top: trl(-12px);
      height: trl(75px);
      .scroll-number {
        position: relative;
        left: trl(-2px);
      }
    }
    .total-box {
      text-align: center;
      // line-height: 14px;
      position: relative;
      color: rgba(255, 255, 255, 0.75);
      top: trlh(-16px);
      .t-item {
        margin-right: trl(20px);
        font-size: trl(14px);
        font-weight: 300;
        &:last-child {
          margin-right: 0px;
          margin-left: trl(20px);
        }
      }
      .icona-01wenhao3 {
        margin-right: trl(8px);
        margin-left: trl(2px);
      }
    }
  }
  .line-box {
    width: 100%;
    margin: 0 auto;
    height: 0;
    position: relative;
    z-index: 11;
    .line-content {
      width: 100%;
      top: trlh(-5px);
      position: absolute;
      .wrap {
        position: relative;
        margin: 0 auto;
        width: trl(488px);
        .light-move-right {
          width: trl(120px);
          height: trl(18px);
          position: absolute;
          top: trlh(-9px);
          left: 50%;
          transform: translateX(trl(-60px));
          // animation: topbreatheMoveRight 1.5s ease-in infinite;
        }
        .light-move-left {
          width: trl(150px);
          height: trl(18px);
          position: absolute;
          top: trlh(-9px);
          transform: translateX(trl(-60px));
          left: 50%;
          // animation: topbreatheMoveLeft 1.5s ease-in infinite;
        }

        .light-icon {
          width: 100%;
          height: trl(10px);
          animation: topbreathe 1.5s ease-in infinite;
        }

        &::after {
          width: 100%;
          content: '';
          position: relative;
          z-index: 0;
          display: block;
          height: trl(1px);
          opacity: 0.26;
          border-top: 1px solid;
          border-image: linear-gradient(270deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))
            1 1;
        }
      }
    }
  }
  .main-content-box {
    position: relative;
    top: trlh(10px);
    left: 0;
  }
  .product-box {
    position: absolute;
    z-index: 200;
  }
  .goods-wrap {
    position: relative;
    border-radius: trl(4px);
    width: trl(404px);
    border: trl(1px) solid #2e3852;
    // background: rgba($color: #142041, $alpha: 0.84);
    background: #111d3c;
    background-clip: padding-box;
    color: #fff;
    z-index: 5;
    height: trlh(272px);
    &.last-margin {
      margin-top: trlh(14px);
    }
    .goods-title {
      padding: trl(14px) trl(16px);
      font-size: trl(14px);
      line-height: trlh(20px);
      position: relative;
      border-bottom: trl(1px) solid #2e3852;
      // border-image: linear-gradient(137deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.16)) 1 1;
      .more {
        cursor: pointer;
        font-weight: 300;
        position: absolute;
        right: trl(8px);
        font-size: trl(12px);
        top: trlh(14px);
        color: rgba(255, 255, 255, 0.5);
        .left-icon {
          font-size: trl(14px);
          display: inline-block;
          transform: rotate(-90deg);
        }
      }
    }
    .goods-list {
      padding: 0 0 trl(16px);
      box-sizing: border-box;
      .el-scrollbar {
        height: trlh(210px);
      }

      tbody {
        overflow-y: auto;
      }
      .table-box {
        width: 100%;

        .th {
          z-index: 2;
          padding: trlh(4px) trl(6px);
          font-weight: 300;
          background: #111d3c;
          position: sticky;
          font-size: trl(12px);
          top: 0;
          padding-bottom: 0px;
          &:first-child {
            padding-left: trl(26px);
            width: trl(120px);
            text-align: left;
          }
          color: rgba(255, 255, 255, 0.5);
        }

        td {
          font-weight: 200;
          padding: 0 trl(6px);
          font-size: trl(12px);
          line-height: trlh(38px);
          font-weight: 400;
        }
      }
      .gd-title {
        padding-right: trl(40px);
        box-sizing: border-box;
        text-align: left;
        display: flex;
        align-items: center;
        position: relative;
        .title {
          display: inline-block;
        }
      }
      .empty-td {
        &.big-padding {
          padding-top: trlh(30px);
        }
        .empty-img {
          width: trl(68px);
          height: trlh(68px);
          display: none;
          margin: 0 auto;
        }
        .empty-a {
          margin-top: trlh(8px);
          // color: #ffb81c;
          display: block;
        }
        .empty-content {
          padding: trlh(50px) 0;
          line-height: 1;
          text-align: center;
          color: rgba(255, 255, 255, 0.5);
          margin-top: trlh(8px);
          .big-screen-tip-content {
            text-align: left;
            // line-height: 14px;
            padding: 10px;
            position: relative;
            line-height: 1.2;
            .t-item {
              font-size: trl(12px);
              color: #010517;
              font-weight: 400;
              &:last-child {
                margin-right: 0px;
                margin-left: trl(20px);
              }
            }
            .icona-01wenhao3 {
              margin-right: trl(8px);
              margin-left: trl(2px);
            }
          }
        }
      }
      .goods-item {
        .one-line {
          width: trl(80px);
          &.fx {
            vertical-align: middle;
            margin-left: trl(4px);
            display: inline-block;
            width: trl(56px);
          }
        }
        .dot-icon {
          display: inline-block;

          font-size: trl(12px);
          color: rgba(255, 255, 255, 0.5);
          vertical-align: middle;
          width: trl(16px);
          height: trlh(16px);
        }
        .dot-icon-span {
          display: inline-block;
          width: trl(24px);
          margin-right: trl(2px);
          text-align: center;
          margin-right: trl(2px);
          font-size: trl(12px);
          color: rgba(255, 255, 255, 0.5);
        }
      }

      .dot {
        text-align: left;
        font-size: trl(12px);
        color: rgba(255, 255, 255, 0.5);
        position: absolute;
        min-width: trl(28px);
        top: 0;
        right: trl(2px);
        .iconfont {
          margin-right: trl(1px);
          font-size: trl(14px);
          color: #fff;
        }
        .dot-span-tip {
          transform: translateY(trl(-2px));
          width: trl(14px);
          color: #fff;
          display: inline-block;
          vertical-align: middle;
          text-align: center;
        }
      }
      .dot-t {
        .iconfont {
          margin-right: trl(-3px);
          color: #fd2d2e;
        }
      }
      .dot-d {
        .iconfont {
          margin-right: trl(-3px);
          color: #00b929;
        }
      }
      .td-rate {
        position: relative;
        padding-left: trl(18px) !important;
        .dot {
          width: auto;
          right: inherit;
          left: trl(2px);
        }
        .dot-t,
        .dot-d {
          .iconfont {
            margin-right: 0;
          }
        }
      }
    }
  }
  @media screen and (min-width: 1920px) {
    .goods-title {
      line-height: trl(20px);
      font-size: trl(12px) !important;
      padding: trlh(10px) trl(16px) !important;
    }
    .more {
      right: trl(8px) !important;
      font-size: trl(10px) !important;
      top: trlh(12px) !important;
      .left-icon {
        font-size: trl(10px) !important;
      }
    }
    .table-box {
      .th {
        padding-bottom: 0 !important;
        font-size: trl(10px) !important;
      }
      td {
        line-height: trl(30px) !important;
      }
    }
  }
  .update-time-wrap {
    position: absolute;
    bottom: trlh(40px);
    right: trl(52px);
    font-weight: 300;
    line-height: trlh(16px);
    color: rgba(255, 255, 255, 0.5);
    font-size: trl(12px);
    z-index: 6;
    .icona-01wenhao3 {
      margin-left: trl(-1px);
    }
    @media screen and (max-width: $maxWidth) {
      bottom: trl(25px);
    }
    .update-time-position {
      position: relative;
    }
    .date-icon {
      cursor: pointer;
      display: none;
      color: rgba(255, 255, 255, 0.5);
      font-size: trl(14px);
    }
    .el-date-editor {
      background: none;
      width: trl(140px);
      /deep/.el-input__inner {
        width: trl(140px);
        background: #111d3c;
        padding-right: trl(10px);
        border: trl(1px) solid #2e3852;
        color: rgba(255, 255, 255, 0.4);
      }
    }
  }
}
.map-container {
  position: absolute;
  width: 58vw;
  height: 60vh;
  right: 0;
  top: 30vh;
}

.data-ring-animate {
  position: absolute;
  width: 0.3%;
  height: 0px;
  border-radius: 0.2%;
  background: linear-gradient(180deg, #0560fd 0%, rgba(250, 251, 255, 0) 100%);
  z-index: 999;
  overflow: visible;
  animation-name: ringAnimate;
  animation-duration: 2s;
  animation-timing-function: linear;

  .ring-dot {
    position: absolute;
    top: -0.1%;
    left: 0;
    width: 0.3%;
    height: 0;
    border-radius: 0.2%;
    background: #0560fd;
    box-shadow: #0560fd 0 0 0.2%;
    animation-name: ringDotAnimate;
    animation-duration: 1s;
    animation-timing-function: linear;
  }
}

@keyframes ringDotAnimate {
  0% {
    height: 0.2%;
    opacity: 0;
  }

  50% {
    height: 0.2%;
    opacity: 1;
  }

  100% {
    height: 0.2%;
    opacity: 0;
  }
}

@keyframes ringAnimate {
  0% {
    height: 0.2%;
    opacity: 0;
  }

  50% {
    height: 4%;
    opacity: 1;
  }

  100% {
    height: 8%;
    opacity: 0;
  }
}
::v-deep {
  .el-loading-mask {
    background-color: rgba(255, 255, 255, 0.01);
  }
}
// @keyframes topbreatheMove {
//   0% {
//     opacity: 0;
//     transform: scale(0);
//   }
//   25% {
//     opacity: 0.6;
//     transform: scale(0.6);
//   }
//   50% {
//     opacity: 0.8;
//     transform: scale(1.5);
//   }
//   75% {
//     opacity: 1;
//   }
//   100% {
//     transform: translateX(368px) scale(1);
//     opacity: 0;
//   }
// }
@keyframes topbreathe {
  0% {
    opacity: 0.6;
    transform: scale(1.2);
  }
  25% {
    opacity: 0.8;
    transform: scale(1.5);
  }
  50% {
    opacity: 1;
    transform: scale(2.5);
  }
  75% {
    opacity: 0.8;
    transform: scale(1.5);
  }
  100% {
    opacity: 0.6;
    transform: scale(1.2);
  }
}
// @keyframes topbreathe {
//   0% {
//     opacity: 1;
//     transform: scale(1);
//   }
//   // 50% {
//   //   opacity: 0.6;
//   //   transform: scale(0.6);
//   // }
//   100% {
//     opacity: 0;
//     transform: scale(0);
//   }
// }
@keyframes topbreatheMoveRight {
  from {
    transform: translateX(trl(-60px));
  }
  to {
    transform: translateX(trl(124px));
  }
}
@keyframes topbreatheMoveLeft {
  from {
    transform: translateX(trl(-60px));
  }
  to {
    transform: translateX(trl(-184px));
  }
}
@keyframes topbreatheMoveSmall {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(trl(258px));
  }
}
.allScreen {
  position: fixed;
  left: 0px;
  top: 0;
  width: 100% !important;
  height: 100% !important;
  z-index: 2000;
  box-sizing: border-box;
  margin: 0;
  overflow: auto;
  @import './screen.scss';
}

.isCollspan.allScreen {
  width: 100% !important;
}
</style>
